import { render } from "./App.vue?vue&type=template&id=0ccacb77"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0ccacb77&lang=css"
script.render = render

export default script